import React from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Segment, Tab, Table } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import SimpleTwoColumnTableRow from '../StudentPersonalInfo/SimpleTwoColumnTableRow';
import PersonBasicInfoTable from '../StudentPersonalInfo/PersonBasicInfoTable';
import ContactFormEditable from '../util/ContactFormEditable';
import '../StudentPersonalInfo/PersonalInfo.css';
import request from '../util/request';
import { addContact, deleteContact, fetchPersonInfo } from '../StudentPersonalInfo/request';
import { FiltersOnStyle, IconHeader, RightHeaderWithButton } from '../Professor/ProfessorInputGrades/css';
import { fetchFaculties, fetchPositions } from '../Lookups/util';
import AccountInfo from '../StudentPersonalInfo/AccountInfo';
import StudentRole from '../StudentService/StudentOverview/StudentRole';
import StaffRole from './StaffRole';
import { extractFileNameFromHeaders } from '../DegreeDocumentPrint/util/util';
import download from 'downloadjs';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


// const formatContacts = (contacts, contactTypes) => {
//     const c1 = contacts.map(c => ({
//         id: c.id,
//         contactType: contactTypes.find(el => el.text == c.type).value || null,
//         value: c.value
//     }));
//     return c1;
// };

export default class PersonalInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            currentStudyProgramInfo: {},

            errorText: '',
            profId: '',

            contactEditMode: false,
            contactTypes: [],
            employee: [],
            personData: {},
            loading: true,

            positions: [],
            orgUnits: [],

            endOfEmploymentDate: new Date()

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onPersonIdChanged = this.onPersonIdChanged.bind(this);
        this.switchContactEditMode = this.switchContactEditMode.bind(this);
        this.switchContactAddMode = this.switchContactAddMode.bind(this);
        this.updateContacts = this.updateContacts.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.onDeleteContact = this.onDeleteContact.bind(this);
        this.onEditContact = this.onEditContact.bind(this);
        this.getProfInfo = this.getProfInfo.bind(this);
        this.getEmployee = this.getEmployee.bind(this);
        this.getPositionsAndOrgUnits = this.getPositionsAndOrgUnits.bind(this);

        this.fetchAccountMail = this.fetchAccountMail.bind(this);
        this.editAccountMail = this.editAccountMail.bind(this);
        this.switchAccountMailEditMode = this.switchAccountMailEditMode.bind(this);
    }

    componentWillMount() {
        this.getPositionsAndOrgUnits();
    }

    componentDidMount() {
        request.fetchContactTypes().then(contactTypes => this.setState({ contactTypes }))
            .then(res => this.onPersonIdChanged());
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    getPositionsAndOrgUnits() {
        axios.all([fetchPositions(), fetchFaculties()])
            .then(axios.spread((positionsRes, facultiesRes) => {
                this.setState({
                    positions: positionsRes.data, orgUnits: facultiesRes.data
                });
            }))
            .catch(err => {
                console.log('Failed to fetch org units or positions');
            });
    }

    getProfInfo() {
        axios({
            method: 'get',
            // url: (this.props.location.pathname === '/lični-podaci-profesora' || this.props.location.pathname === '/personal-info-professor') ? 'professor/personal-information/' : `professor/personal-information/${this.props.location.state.id}`
            url: 'professor/personal-information/'
        })
            .then(res => {
                const personData = res.data;
                const profId = res.data.id;
                this.setState({ personData, loading: false, profId });
            })
            .catch(err => {
                console.log('Failed to fetch professor personal info');
                this.setState({ error: true });
            });
    }

    getEmployee() {
        axios.get('employees/employee')
            .then(res => {
                const employee = res.data;
                this.setState({ employee });
            })
            .catch(err => {
                console.log('Failed to fetch employee');
                this.setState({ error: true });
            });
    }

    onPersonIdChanged() {
        this.setState(() => {
            let roleString = '';
            if (this.props.location.pathname === '/lični-podaci' || this.props.location.pathname === '/osobni-podaci' || this.props.location.pathname === '/personal-information') {
                roleString = 'profesor';
                fetchPersonInfo(roleString, this.state.contactTypes)
                    .then(personData => {
                        this.setState({ personData });
                        this.setState({ loading: false });
                    }).then(() => this.fetchAccountMail());
            }
            if (this.props.location.pathname === '/nastavno-osoblje/lični-podaci') {
                roleString = 'studentService';
                fetchPersonInfo(roleString, this.state.contactTypes, this.props.location.state.id)
                    .then(personData => {
                        this.setState({ personData });
                        this.setState({ loading: false });
                    }).then(() => this.fetchAccountMail());
            }

            if (this.props.location.pathname === '/spisak-zaposlenika/lični-podaci') {
                roleString = 'studentService';
                fetchPersonInfo(roleString, this.state.contactTypes, this.props.location.state.id)
                    .then(personData => {
                        this.setState({ personData });
                        this.setState({ loading: false });
                    }).then(() => this.fetchAccountMail());
            }
        });
    }


    onDeleteContact(contactId) {
        const role = 'employee';
        deleteContact(contactId, role)
            .then(res => { toast(<FormattedMessage id="student.deleteContactToast" />); this.updateContacts(); });
    }

    onEditContact(requestBody) {
        axios.put('employees/change-contact', { ...requestBody })
            .then(res => {
                toast(<FormattedMessage id="student.editContactToast" />);
                this.updateContacts();
            })
            .catch(err => {
                toast(<FormattedMessage id="student.editContactErrToast" />);
            });
    }

    onAddNewContact(contact) {
        const role = 'employee';
        addContact(contact, this.state.contactTypes, role)
            .then(res => { toast(<FormattedMessage id="student.addContactToast" />); this.updateContacts(); });
    }


    switchContactEditMode() {
        this.setState(prevState => ({ contactEditMode: !prevState.contactEditMode }));
    }

    updateContacts() {
        this.getProfInfo();
        this.getEmployee();
        // fetchPersonInfo(role, this.state.contactTypes)
        //  .then(personData => this.setState({ personData }));
    }

    switchContactAddMode() {
        this.setState(prevState => ({ contactAddMode: !prevState.contactAddMode }));
    }
    handleInputChange(event) {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        this.setState({
            [name]: value
        });
    }


    fetchAccountMail() {
        let obj = {
            id: this.state.personData.id
        };
        this.setState({ loaded: false });
        axios.post('/user/get-user-data/', { ...obj })
            .then(res => {
                // eslint-disable-next-line no-unused-expressions
                res.data ?
                    this.setState({ accountMail: res.data.eMail, username: res.data.username, loaded: true })
                    : this.setState({ accountMail: null, loaded: true });
            }).catch(err => {
                this.setState({ accountMail: null, loaded: true });
            });
    }

    switchAccountMailEditMode() {
        this.setState({ editAccountMail: !this.state.editAccountMail });
    }

    editAccountMail(accountMail) {
        axios.put(`user/edit-user-mail/${this.state.personData.id}/`, accountMail)
            .then((res) => {
                this.fetchAccountMail();
                this.switchAccountMailEditMode();
                toast('Uspješno ste izmijenili e-mail!');
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena e-maila nije izvršena.');
            });
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const {
            personData, positions, orgUnits, accountMail, username, loaded,
            editAccountMail
        } = this.state;
        return (
            <div >
                <Header as="h1"><FormattedMessage id="common.personalInfo" /></Header>
                {(localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') ? <Grid columns={2} className="stackable" centered >
                    <Grid.Column >
                        <Segment.Group raised>
                            <Segment clearing>
                                <Header as="h3">
                                    <FormattedMessage id="common.contact" />
                                    {(this.props.location.pathname === '/lični-podaci' || this.props.location.pathname === '/osobni-podaci') && <Header style={IconHeader} floated="right" onClick={this.switchContactEditMode}>
                                        <Button
                                            basic
                                            color="blue"
                                            size="small"
                                            style={RightHeaderWithButton}
                                            onClick={this.changeStep}
                                        >
                                            {!this.state.contactEditMode ? <FormattedMessage id="common.editOrAdd" /> : <FormattedMessage id="common.cancelO" />}
                                        </Button>
                                    </Header>}
                                </Header>
                            </Segment>
                            <ContactFormEditable
                                contacts={this.state.personData.contacts || []}
                                contactEditMode={this.state.contactEditMode}
                                contactTypes={this.state.contactTypes}
                                onAddNewContact={this.onAddNewContact}
                                onDeleteContact={this.onDeleteContact}
                                onEditContact={this.onEditContact}
                                f
                            />
                        </Segment.Group>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="professorInputGrades.positions" /></Header>
                            </Segment>
                            <Segment>
                                {!this.props.isEmployee ? <Table celled selectable compact size="small" >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell><FormattedMessage id="common.faculty" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="orgUnitDetailed.staffPosition" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="common.startEngagement" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="common.endEngagement" /></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body> {personData.positions.sort((a, b) => b.startDate - a.startDate).map((el, index) =>
                                        (<Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.organizationalUnitName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.positionName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.startDate ? moment(el.startDate).format('D. M. YYYY.') : '-'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '-'}
                                            </Table.Cell>
                                        </Table.Row>))}
                                    </Table.Body>
                                </Table> : <FormattedMessage id="common.noPositionInfo" />}
                                {/* <Table celled size="small" unstackable compact> */}
                                {/*    <Table.Header> */}
                                {/*        <Table.Row> */}
                                {/*        </Table.Row> */}
                                {/*    </Table.Header> */}
                                {/*    <Table.Body>{personData.positions.map(el => ( */}
                                {/*        <SimpleTwoColumnTableRow */}
                                {/*            name={orgUnits.find(e => e.id === el.organizationalUnitId).name} */}
                                {/*            keyName="position" */}
                                {/*            value={positions.find(e => e.id === el.positionId).name} */}
                                {/*        />))} */}
                                {/*    </Table.Body> */}
                                {/* </Table> */}
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="professorInputGrades.titles" /></Header>
                            </Segment>
                            <Segment>
                                {!this.props.isEmployee ? <Table celled selectable compact size="small" >
                                    <Table.Header>
                                        <Table.Row>

                                            <Table.HeaderCell><FormattedMessage id="common.academicTitle" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="common.titleElection" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="common.titleExpiration" /></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body> {personData.titles.sort((a, b) => b.promotionDate - a.promotionDate).map((el, index) =>
                                        (<Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.academicTitle.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.promotionDate ? moment(el.promotionDate).format('D. M. YYYY.') : '-'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.expirationDate ? moment(el.expirationDate).format('D. M. YYYY.') : '-'}
                                            </Table.Cell>
                                        </Table.Row>))}
                                    </Table.Body>
                                </Table> : <FormattedMessage id="common.noEmploymentInfo" /> }
                                {/* <Table celled size="small" unstackable compact> */}
                                {/*    <Table.Header> */}
                                {/*        <Table.Row> */}
                                {/*        </Table.Row> */}
                                {/*    </Table.Header> */}
                                {/*    <Table.Body>{personData.positions.map(el => ( */}
                                {/*        <SimpleTwoColumnTableRow */}
                                {/*            name={orgUnits.find(e => e.id === el.organizationalUnitId).name} */}
                                {/*            keyName="position" */}
                                {/*            value={positions.find(e => e.id === el.positionId).name} */}
                                {/*        />))} */}
                                {/*    </Table.Body> */}
                                {/* </Table> */}
                            </Segment>
                        </Segment.Group>

                        {this.props.admin && <Segment.Group raised style={this.props.active ? { borderTop: '2px solid #FF0000' } : {}} id={this.props.active ? 'redSegment' : ''}>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="professorInputGrades.endOfEmployment" /></Header>
                            </Segment>
                            <Segment clearing>
                                {this.props.active ? <Form widths="equal">
                                    <Form.Field>
                                        <label><FormattedMessage id="professorInputGrades.endOfEmploymentDate" /></label>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            defaultValue={new Date()}
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'endOfEmploymentDate')}
                                            value={this.state.endOfEmploymentDate}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Button
                                            color="red"
                                            basic="true"
                                            floated="right"
                                            onClick={() => this.props.endOfEmployment(this.state.endOfEmploymentDate)}
                                        >
                                            <FormattedMessage id="professorInputGrades.endOfEmploymentButton" /></Button>
                                    </Form.Field>
                                </Form>
                                    : <Table celled unstackable compact size="small">
                                        <Table.Header>
                                            <Table.Row>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            <SimpleTwoColumnTableRow
                                                name={<FormattedMessage id="professorInputGrades.endOfEmploymentDate" />}
                                                keyName="dateEnd"
                                                value={this.props.dateEnd ? moment(this.props.dateEnd).format('D. M. YYYY.') : moment(this.state.endOfEmploymentDate).format('D. M. YYYY.')}
                                            />
                                        </Table.Body>
                                    </Table>
                                }
                            </Segment>
                        </Segment.Group>}
                    </Grid.Column>
                </Grid> :
                <Grid columns={2} className="stackable" centered >
                        <Grid.Column >
                        <Segment.Group raised>
                                <Segment>
                                <Header as="h3"><FormattedMessage id="student.accountInfo" />
                                        {username ? <Header style={IconHeader} floated="right" >
                                        <Icon />
                                        <Icon
                                                link
                                                circular
                                                basic="true"
                                                floated="right"
                                                name={this.state.editAccountMail ? 'close' : 'pencil'}
                                                color={this.state.editAccountMail ? null : 'green'}
                                                onClick={this.switchAccountMailEditMode}
                                            />
                                    </Header> :
                                            loaded && (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator') && <Header style={IconHeader} floated="right" >
                                                <Popup
                                                    content="Generiši pristupne podatke"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            onClick={() => {
                                                                axios({
                                                                    method: 'post',
                                                                    url: `/generate-users/employee/${localStorage.getItem('organizationalUnitEmployeeId')}/`,
                                                                    responseType: 'blob'
                                                                })
                                                                    .then((res) => {
                                                                        this.fetchAccountMail();
                                                                        const fileName = extractFileNameFromHeaders(res.headers);
                                                                        download(res.data, fileName);
                                                                        toast('Uspješno ste generisali pristupne podatke.');
                                                                    }).catch(err => {
                                                                        if (err.response.data === 'Student is dropped out!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za ispisane studente.');
                                                                        } else if (err.response.data === 'Student is graduated!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za studente koji su diplomirali.');
                                                                        } else if (err.response.data === 'Student is locked!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za zaključane studente.');
                                                                        } else if (err.response.data === 'Student already have an account!') {
                                                                            toast('Student već ima pristupne podatke.');
                                                                        } else if (err.response.data === 'Student switched to new study program!') {
                                                                            toast('Student je prešao na novi studijski program.');
                                                                        } else if (err.response.data.text === 'Student is not enrolled in current academic year!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za studente koji nisu upisani u trenutnu akademsku godinu.');
                                                                        } else {
                                                                            toast('Došlo je do greške! Pristupni podaci nisu generisani.');
                                                                        }
                                                                    });
                                                            }}
                                                            size="small"
                                                            style={FiltersOnStyle}
                                                            basic
                                                            color="blue"
                                                            fluid
                                                        >
                                                            Pristupni podaci

                                                        </Button>}
                                                />


                                            </Header>


                                        }

                                    </Header>
                            </Segment>
                                <Segment>
                                <AccountInfo
                                        accountMail={accountMail}
                                        username={username}
                                        editAccountMailFlag={editAccountMail}
                                        editAccountMail={this.editAccountMail}
                                    />
                            </Segment>
                            </Segment.Group>
                        <Segment.Group raised>
                                <Segment>
                                <Header as="h3"><FormattedMessage id="student.basicInfo" /></Header>
                            </Segment>
                                <Segment>
                                <PersonBasicInfoTable
                                        employee
                                        personInfoData={personData}
                                    />
                            </Segment>
                            </Segment.Group>
                        {(localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') && <Segment.Group raised>
                                <Segment>
                                <Header as="h3"><FormattedMessage id="student.userRole" /></Header>
                            </Segment>
                                <Segment>
                                <StaffRole />
                            </Segment>
                            </Segment.Group>}

                    </Grid.Column>
                        <Grid.Column >
                        <Segment.Group raised>
                                <Segment clearing>
                                <Header as="h3">
                                        <FormattedMessage id="common.contact" />
                                        {(this.props.location.pathname === '/lični-podaci' || this.props.location.pathname === '/osobni-podaci') && <Header style={IconHeader} floated="right" onClick={this.switchContactEditMode}>
                                        <Button
                                                basic
                                                color="blue"
                                                size="small"
                                                style={RightHeaderWithButton}
                                                onClick={this.changeStep}
                                            >
                                                {!this.state.contactEditMode ? <FormattedMessage id="common.editOrAdd" /> : <FormattedMessage id="common.cancelO" />}
                                            </Button>
                                        </Header>}
                                    </Header>
                            </Segment>
                                <ContactFormEditable
                                    contacts={this.state.personData.contacts || []}
                                    contactEditMode={this.state.contactEditMode}
                                    contactTypes={this.state.contactTypes}
                                    onAddNewContact={this.onAddNewContact}
                                    onDeleteContact={this.onDeleteContact}
                                    onEditContact={this.onEditContact}
                                    f
                            />
                            </Segment.Group>
                        <Segment.Group raised>
                                <Segment>
                                <Header as="h3"><FormattedMessage id="professorInputGrades.positions" /></Header>
                            </Segment>
                                <Segment>
                                {!this.props.isEmployee ? <Table celled selectable compact size="small" >
                                        <Table.Header>
                                        <Table.Row>
                                                <Table.HeaderCell><FormattedMessage id="common.faculty" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="orgUnitDetailed.staffPosition" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.startEngagement" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.endEngagement" /></Table.HeaderCell>
                                            </Table.Row>
                                    </Table.Header>

                                        <Table.Body> {personData.positions.sort((a, b) => b.startDate - a.startDate).map((el, index) =>
                                            (<Table.Row key={index}>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.organizationalUnitName}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.positionName}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.startDate ? moment(el.startDate).format('D. M. YYYY.') : '-'}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '-'}
                                                </Table.Cell>
                                            </Table.Row>))}
                                    </Table.Body>
                                    </Table> : <FormattedMessage id="common.noPositionInfo" />}
                                {/* <Table celled size="small" unstackable compact> */}
                                {/*    <Table.Header> */}
                                {/*        <Table.Row> */}
                                {/*        </Table.Row> */}
                                {/*    </Table.Header> */}
                                {/*    <Table.Body>{personData.positions.map(el => ( */}
                                {/*        <SimpleTwoColumnTableRow */}
                                {/*            name={orgUnits.find(e => e.id === el.organizationalUnitId).name} */}
                                {/*            keyName="position" */}
                                {/*            value={positions.find(e => e.id === el.positionId).name} */}
                                {/*        />))} */}
                                {/*    </Table.Body> */}
                                {/* </Table> */}
                            </Segment>
                            </Segment.Group>
                        <Segment.Group raised>
                                <Segment>
                                <Header as="h3"><FormattedMessage id="professorInputGrades.titles" /></Header>
                            </Segment>
                                <Segment>
                                {!this.props.isEmployee ? <Table celled selectable compact size="small" >
                                        <Table.Header>
                                        <Table.Row>

                                                <Table.HeaderCell><FormattedMessage id="common.academicTitle" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.titleElection" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.titleExpiration" /></Table.HeaderCell>
                                            </Table.Row>
                                    </Table.Header>

                                        <Table.Body> {personData.titles.sort((a, b) => b.promotionDate - a.promotionDate).map((el, index) =>
                                            (<Table.Row key={index}>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.academicTitle.name}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.promotionDate ? moment(el.promotionDate).format('D. M. YYYY.') : '-'}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.expirationDate ? moment(el.expirationDate).format('D. M. YYYY.') : '-'}
                                                </Table.Cell>
                                            </Table.Row>))}
                                    </Table.Body>
                                    </Table> : <FormattedMessage id="common.noEmploymentInfo" /> }
                                {/* <Table celled size="small" unstackable compact> */}
                                {/*    <Table.Header> */}
                                {/*        <Table.Row> */}
                                {/*        </Table.Row> */}
                                {/*    </Table.Header> */}
                                {/*    <Table.Body>{personData.positions.map(el => ( */}
                                {/*        <SimpleTwoColumnTableRow */}
                                {/*            name={orgUnits.find(e => e.id === el.organizationalUnitId).name} */}
                                {/*            keyName="position" */}
                                {/*            value={positions.find(e => e.id === el.positionId).name} */}
                                {/*        />))} */}
                                {/*    </Table.Body> */}
                                {/* </Table> */}
                            </Segment>
                            </Segment.Group>

                        {this.props.admin && <Segment.Group raised style={this.props.active ? { borderTop: '2px solid #FF0000' } : {}} id={this.props.active ? 'redSegment' : ''}>
                                <Segment>
                                <Header as="h3"><FormattedMessage id="professorInputGrades.endOfEmployment" /></Header>
                            </Segment>
                                <Segment clearing>
                                {this.props.active ? <Form widths="equal">
                                        <Form.Field>
                                        <label><FormattedMessage id="professorInputGrades.endOfEmploymentDate" /></label>
                                        <DateTimePicker
                                                format="D. M. YYYY."
                                                defaultValue={new Date()}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'endOfEmploymentDate')}
                                                value={this.state.endOfEmploymentDate}
                                            />
                                    </Form.Field>
                                        <Form.Field>
                                        <Button
                                                color="red"
                                                basic="true"
                                                floated="right"
                                                onClick={() => this.props.endOfEmployment(this.state.endOfEmploymentDate)}
                                            >
                                                <FormattedMessage id="professorInputGrades.endOfEmploymentButton" /></Button>
                                    </Form.Field>
                                    </Form>
                                        : <Table celled unstackable compact size="small">
                                            <Table.Header>
                                                <Table.Row>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                <SimpleTwoColumnTableRow
                                                    name={<FormattedMessage id="professorInputGrades.endOfEmploymentDate" />}
                                                    keyName="dateEnd"
                                                    value={this.props.dateEnd ? moment(this.props.dateEnd).format('D. M. YYYY.') : moment(this.state.endOfEmploymentDate).format('D. M. YYYY.')}
                                                />
                                            </Table.Body>
                                        </Table>
                                    }
                            </Segment>
                            </Segment.Group>}
                    </Grid.Column>
                    </Grid>}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/PersonalInfo.js